export const selectStatsList = state => state.accounting.stats;

export const selectIsStatsLoading = state => state.accounting.isStatsLoading;

export const selectRecordInfo = state => state.accounting.recordInfo;

export const selectIsRecordInfoLoading = state =>
  state.accounting.isRecordInfoLoading;

export const selectCategories = state =>
  state.accounting.nodesAndPartsForDiagnostics;

export const selectCommercialOfferData = state =>
  state.accounting.commercialOfferData;

export const selectCommercialOffer = state => state.accounting.commercialOffer;

export const selectCOLoading = state => state.accounting.isCOLoading;

export const selectPartOffersByOEM = state => state.accounting.partOffersByOEM;

export const selectIsPartOffersByOEMLoading = state =>
  state.accounting.isPartOffersByOEMLoading;

export const selectAdditionalSearchParts = state =>
  state.accounting.additionalSearchParts;

export const selectDiagLoading = state => state.accounting.isDiagLoading;

export const selectDiagnostic = state => state.accounting.diagnostic;

export const selectDiagnosticId = state => state.accounting.diagnosticId;

export const selectBufferDiagnostic = state =>
  state.accounting.bufferDiagnostic;

export const selectIsBufferDiagnosticLoading = state =>
  state.accounting.isBufferDiagnosticLoading;

export const selectDiagCreateLoading = state =>
  state.accounting.isDiagCreateLoading;

export const selectClientsList = state => state.accounting.clientsList;

export const selectDataForOrder = state => state.accounting.order;

export const selectLoading = state => state.accounting.isLoading;

export const selectIsCarsListLoading = state =>
  state.accounting.isCarsListLoading;

export const selectAppeal = state => state.accounting.appeal;

export const selectRepairDetails = state => state.accounting.repairDetails;

export const selectIsRepairLoading = state => state.accounting.isRepairLoading;

export const selectError = state => state.accounting.error;

export const selectCarsListError = state => state.accounting.carsListError;

export const selectReceivingFromSupplier = state => state.accounting.receiving;

export const selectPartsSearchStatuses = state =>
  state.accounting.partsSearchStatuses;

export const selectChosenPeriod = state => state.accounting.chosenPeriod;

export const selectDiagnosticTree = state => state.accounting.diagnosticTree;

export const selectDiagnosticTreeLoading = state =>
  state.accounting.isDiagnosticTreeLoading;

export const selectPartDetailsForDiagnostic = state =>
  state.accounting.partDetailsForDiagnostic;

export const selectPartDetailsForDiagnosticLoading = state =>
  state.accounting.isPartDetailsForDiagnosticLoading;

export const selectParticularOrderBySupplier = state =>
  state.accounting.particularOrderBySupplier;

export const selectIsParticularOrderBySupplierLoading = state =>
  state.accounting.isParticularOrderBySupplierLoading;

export const selectChosenPartsInDiag = state => state.accounting.chosenPartsInDiag;

export const selectModalCarId = state => state.accounting.modalCarId;

export const selectGlobalOfferObj = state => state.accounting.globalOfferObj;

export const selectNewPartInRepair = state => state.accounting.newPartInRepair;

export const selectIsAddingNewRow = state => state.accounting.isAddingNewRow;

